import { Fragment } from "react";
import { DefinitionDescription, DefinitionTerm } from "@/components/ui/definition-list.tsx";
import useConfigCode from "@/features/sub-families/hooks/use-config-code.ts";
import { formatColour } from "@/features/sub-families/utils/colours.ts";
import { getPartDescriptor } from "@/features/sub-families/utils/parts.ts";
import { useAppSelector } from "@/redux/store.ts";

export default function PartDetails() {
    const { getConfigCodeByDescriptor } = useConfigCode();

    const parts = useAppSelector((state) => state.parts.items);

    if (!parts.length) return null;

    return parts.map((part) => {
        const descriptor = getPartDescriptor(part);
        if (!descriptor) return null;

        const colourCode = getConfigCodeByDescriptor(descriptor);
        if (!colourCode) return null;

        const colour = part.colors.find(({ code }) => code === colourCode) ?? null;
        if (!colour) return null;

        return (
            <Fragment key={part.id}>
                <DefinitionTerm>{part.label}</DefinitionTerm>
                <DefinitionDescription>{formatColour(colour)}</DefinitionDescription>
            </Fragment>
        );
    });
}
